export enum FormTags {}
export enum FormItemTags {
  AddFundsModal = 'addFundsModal',
  Standard = 'standard',
}
